import 'reflect-metadata';
import { Expose } from 'class-transformer';
import { IsInt } from 'class-validator';
import { LengthValue } from './LengthValue'; // Adjust the import path as needed
import { ELengthValueType } from './ELengthValueType'; // Adjust the import path as needed

export class LengthValueMillimeter extends LengthValue {

    @Expose()
    @IsInt()
    private _millimeter: number;

    constructor(millimeter: number) {
        super(millimeter);
        this._millimeter = millimeter;
    }

    @Expose()
    get type(): ELengthValueType {
        return ELengthValueType.Millimeter;
    }

    @Expose()
    get millimeter(): number {
        return this._millimeter;
    }

    @Expose()
    get centimeter(): number {
        return this._millimeter / 10;
    }

    @Expose()
    get meter(): number {
        return this._millimeter / 1000;
    }
}
